module.exports = __webpack_public_path__ + "static/media/ipsum_mcc.8ecf59e9.png";